export default __webpack_public_path__ + "static/media/raccoon.c0fffbe1.webp";